import React, { Component } from 'react';
import logoWhite from "../../assets/icons/vcep_logo_white.png";
import "./HeaderAdmin.css";
import { sessionFlush } from "../../utils/sessionUtil";
import { recordError } from "../../utils/commonUtil";
class HeaderAdmin extends Component {
    constructor(props){
      super(props);
      this.intiateLogout = this.intiateLogout.bind(this);
    }
    intiateLogout() {
      try {        
        sessionFlush("sessionTimeOut");
      } catch (error) {
        recordError(error);
      }
    }
    render() {      
      return (
        <div className="admin-header ah-shorthand">
            <div className="ah-inner-wrap main-max-width-container">
                <div className="ah-left"><img src={logoWhite} alt="Vanguard charitable logo"/></div>
                <div className="ah-right"><span onClick={this.intiateLogout}>LOGOUT</span></div>
            </div>
        </div>
      )
    }
  }
  
  export default HeaderAdmin;